import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {withTranslation} from 'react-i18next';
import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc';
import style from '../ResidentialMarket/Basket.css';
import classNames from 'classnames';

/**
 * Selected apartments basket: Regular call for applications - before the user has submitted the application
 */

class ListWrapper extends Component {

	constructor({items}) {
		super()
		this.state = {
			isSorting: false
		};
	}

	static propTypes = {
		items: PropTypes.array,
		className: PropTypes.string,
		itemClass: PropTypes.string,
		width: PropTypes.number,
		height: PropTypes.number,
		onSortStart: PropTypes.func,
		onSortEnd: PropTypes.func,
		component: PropTypes.func,
		shouldUseDragHandle: PropTypes.bool
	}

	static defaultProps = {
		className: classNames(style.list, style.stylizedList),
		itemClass: classNames(style.item, style.stylizedItem)
	}

	onSortStart = () => {
		let {onSortStart} = this.props;
		this.setState({isSorting: true})

		if (onSortStart) {
			onSortStart(this.refs.component)
		}
	}

	onSortEnd = ({oldIndex, newIndex}) => {
		let {onSortEnd} = this.props;

		// this.props.itemMove
		this.setState({
			isSorting: false
		})

		this.props.movePositionInBasket(oldIndex, newIndex)

		if (onSortEnd) {
			onSortEnd(this.refs.component)
		}
	}

	render() {
		const Component = this.props.component;
		const {isSorting} = this.state;
		const {items} = this.props;
		const props = {
			isSorting,
			items,
			onSortEnd: this.onSortEnd,
			onSortStart: this.onSortStart,
			ref: "component",
			useDragHandle: this.props.shouldUseDragHandle
		}

		return <Component {...this.props} {...props} />
	}
}

/**
 * Have the title of the CallForApplicationItem displayed on two lines
 *
 * @param {string} value
 * @returns {string}
 */
const formatTitle = (value) => {
	let formattedValue = <span>{value}</span>;
	if (value) {
		const titleParts = value.split(' – ')
		if (titleParts.length > 1) {
			formattedValue = <span>{titleParts[0]} <br/> {titleParts[1]}</span>;
		}
	}
	return formattedValue
}

const formatStars = (pos) => {
	let stars = '';
	let i = 0;

  // Can be set in ApplicationForm Node, defaults to 5 if not set
  let maximumNumberOfItemsInBasket = parseInt(AblCh.maximumNumberOfItemsInBasket);
  let numOfStars = (maximumNumberOfItemsInBasket > 0 ? maximumNumberOfItemsInBasket : 5) - (pos - 1)

  while (i < numOfStars) {
		stars = stars + '♥︎';
		i++;
	}
	return stars;
};

const Item = SortableElement((props) => {
	return (
		<div className="basket__item">
			<div className="myrating">
				{formatStars(props.position)}
			</div>
			<div className="basket__item-position">
				Ausschreibung Nr. {props.value.position}
			</div>
			<div className="title">
				{formatTitle(props.value.title)}<br />
				{props.value.realEstateObject.floor}
			</div>
		</div>
	)
})

const SortableList = SortableContainer(({className, items, itemClass, sortingIndex, shouldUseDragHandle, sortableHandlers}) => {
	return (
		<div className={className} {...sortableHandlers}>
			{items.map((value, index) => {
					return (
						<Item
							key={`item-${value.__identity}`}
							className={itemClass}
							sortingIndex={sortingIndex}
							index={index}
							position={index + 1}
							value={value}
							height={40}
							shouldUseDragHandle={shouldUseDragHandle}
						/>
					)
				}
			)}
		</div>
	)
})

// Decorate the class.
@withTranslation()
export default class BasketSummaryNew extends Component {

	/**
	 * @param {object} props
	 */
	constructor(props) {
		super(props)
	}

	/**
	 * @returns {JSX.Element}
	 */
	render() {
		const {t} = this.props;

		return (
			<div>
				<div className="basket__summary clearfix">
					<div><h3>{t('basket.applicationfor', {count: this.props.items.length})}</h3></div>
					<ListWrapper component={SortableList}
					             axis={'y'}
					             className={classNames(style.list, style.stylizedList)}
					             itemClass={classNames(style.stylizedItem)}
					             movePositionInBasket={this.props.movePositionInBasket}
					             helperClass={style.stylizedHelper}
					             items={this.props.items}/>

					<div className="sortinfo">
					  {t('basket.sortinfo')}
					</div>
					{AblCh.applicationIdentifier && (
						<button type="button"
						        onClick={() => {
							        window.history.back()
						        }}
						        className="btn btn-link btn-sm">
							zurück zum Wohnungsmarkt
						</button>
					)}
				</div>
			</div>
		)
	}
}
